import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://bloisetech.com.br';
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;
const SITE_NAME = 'Bloise Tech';

/**
 * SEO por página para o site institucional (público/indexável).
 *
 * @param {string} title       Título da aba/OG (sufixado com a marca, salvo se `bare`).
 * @param {string} description Meta description e og:description.
 * @param {string} path        Caminho relativo p/ canonical e og:url (ex.: "/privacidade").
 * @param {string} [image]     URL absoluta da imagem OG. Default: logo.
 * @param {boolean} [noindex]  Se true, emite robots noindex.
 * @param {boolean} [bare]     Se true, usa o título exatamente como recebido.
 */
export default function Seo({ title, description, path = '/', image, noindex = false, bare = false }) {
  const url = `${SITE_URL}${path}`;
  const fullTitle = bare ? title : `${title} — ${SITE_NAME}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
